(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('ProjectStatusService', ProjectStatusService);

    ProjectStatusService.$inject = ['ProjectStatus', '$q', '_'];

    /* @ngInject */
    function ProjectStatusService(ProjectStatus, $q, _) {
        var steps, stepStatuses, abortStatuses, orderStatuses;

        var service = {
            load: load,
            getSteps: getSteps,
            getStepsStatuses: getStepsStatuses,
            getAbortStatuses: getAbortStatuses,
            getOrderStatuses: getOrderStatuses,

            isTerminateStep: isTerminateStep,
            isArchiveStep: isArchiveStep,
            defineStepAndStatus: defineStepAndStatus,
            getAvailableSteps: getAvailableSteps
        };

        return service;

        function load() {
            return ProjectStatus.get()
                .$promise
                .then(function(response) {
                    steps = response.step;
                    stepStatuses = response.step_status;
                    abortStatuses = response.abort_status;
                    orderStatuses = response.order_status;
                    return response;
                }, function(e) {
                    return $q.reject(e);
                });
        }

        function getSteps() {
            return steps;
        }

        function getStepsStatuses() {
            return stepStatuses;
        }

        function getAbortStatuses() {
            return abortStatuses;
        }

        function getOrderStatuses() {
            return orderStatuses;
        }

        function isTerminateStep(step) {
            return step.status != 1;
        }

        function isArchiveStep(step) {
            return step.status == 3;
        }

        function defineStepAndStatus(project) {
            if(!_.isNull(project.abort_status)) {
                project.abortAlias = _.find(abortStatuses, {id: project.abort_status})['name'];
            }
            project.statusAlias = _.find(orderStatuses, {id:project.status})['name'];
            project.step.statusAlias =  _.find(stepStatuses, {id: project.step.status})['name'];
        }

        function getAvailableSteps(currentStep) {
            var idx = _.findIndex(steps, function(step) {
                return step.code > currentStep.code && step.flag_chain;
            });
            return _.filter(steps, function(step, id) {
                return step.code >= currentStep.code && id <= idx;
            });
        }

    }

})();

